import _ from "lodash";
import QueryEmployeeBookingInvitationsSent from "graphql/queries/QueryEmployeeBookingInvitationsSent";
import { constantsGraphql } from 'utils/constants/constants'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import HelperDate, { dateFormat } from 'utils/helper-date'

const FetchBookingInvitationSent = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {} ) => {
		const variables = {
			active: constantsGraphql.YES_NO,
			booking_date: HelperDate.date().subtract(7, 'days').format( dateFormat.DATE ) + '_after_equal'
		}
		
		GraphqlGroupedBuilder.addQuery( 'invitations_sent', QueryEmployeeBookingInvitationsSent, {
			variables,
			resultPath: [ 'employee_booking_invitations_sent' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( {
						invitations: result,
					} );
				}
			}
		})
	}
}

export default FetchBookingInvitationSent
